export const Providers = {
    OpenAI : "OpenAI",
    OpenAI_Compatible : "OpenAI-Compatible Endpoints (Together AI, etc.)",
    OpenAI_Text : "OpenAI Text Completion",
    OpenAI_Text_Compatible : "OpenAI-Compatible Text Completion Models (Together AI, etc.)",
    Azure : "Azure",
    Azure_AI_Studio : "Azure AI Foundry (Studio)",
    Anthropic : "Anthropic",
    Vertex_AI : "Vertex AI (Anthropic, Gemini, etc.)",
    Google_AI_Studio : "Google AI Studio",
    Bedrock : "Amazon Bedrock",
    Groq : "Groq",
    MistralAI : "Mistral AI",
    Deepseek : "Deepseek",
    Cohere : "Cohere",
    Databricks : "Databricks",
    Ollama : "Ollama",
    xAI : "xAI",
    AssemblyAI : "AssemblyAI",
    Cerebras : "Cerebras",
    Sambanova : "Sambanova",
    Perplexity : "Perplexity",
    TogetherAI : "TogetherAI",
    Openrouter : "Openrouter",
    FireworksAI : "Fireworks AI",
    Triton : "Triton",
    Deepgram : "Deepgram",
    ElevenLabs : "ElevenLabs"
};

  
export const provider_map = {
    OpenAI: "openai",
    OpenAI_Text: "text-completion-openai",
    Azure: "azure",
    Azure_AI_Studio: "azure_ai",
    Anthropic: "anthropic",
    Google_AI_Studio: "gemini",
    Bedrock: "bedrock",
    Groq: "groq",
    MistralAI: "mistral",
    Cohere: "cohere",
    OpenAI_Compatible: "openai-compatible",
    OpenAI_Text_Compatible: "text-completion-openai",
    Vertex_AI: "vertex_ai",
    Databricks: "databricks",
    xAI: "xai",
    Deepseek: "deepseek",
    Ollama: "ollama",
    AssemblyAI: "assemblyai",
    Cerebras: "cerebras",
    Sambanova: "sambanova",
    Perplexity: "perplexity",
    TogetherAI: "together_ai",
    Openrouter: "openrouter",
    FireworksAI: "fireworks_ai",
    Triton: "triton",
    Deepgram: "deepgram",
    ElevenLabs: "elevenlabs"
};

export const llmProvidersArray = Object.entries(Providers).map(([key, value]) => ({
  label: value,
  value: provider_map[key]
}));


export const ModelModes = [
  { value: "chat", label: "Chat - /chat/completions" },
  { value: "completion", label: "Completion - /completions" },
  { value: "embedding", label: "Embedding - /embeddings" },
  { value: "audio_speech", label: "Audio Speech - /audio/speech" },
  { value: "audio_transcription", label: "Audio Transcription - /audio/transcriptions" },
  { value: "image_generation", label: "Image Generation - /images/generations" },
  { value: "rerank", label: "Rerank - /rerank" },
  { value: "realtime", label: "Realtime - /realtime"}
]; 





/** 특정 provider + mode 에 해당하는 모델 키 목록 */
export function getModelKeysForProviderAndMode(modelMap, slug, mode) {
  const keys = getModelKeysForProviderSlug(modelMap, slug);
  if (!mode) return keys;
  return keys.filter(key => modelMap[key]?.mode === mode);
}

/** provider 에서 실제로 사용되는 ModelModes 항목만 반환 */
export function getAvailableModesForProvider(modelMap, slug) {
  const keys = getModelKeysForProviderSlug(modelMap, slug);
  const modes = new Set(keys.map(key => modelMap[key]?.mode).filter(Boolean));
  return ModelModes.filter(m => modes.has(m.value));
}

/** LiteLLM ui getProviderModels 와 동일한 키 목록 (모델 id = model_prices 의 키) */
export function getModelKeysForProviderSlug(modelMap, slug) {
  if (!slug || !modelMap || typeof modelMap !== 'object') return [];

  const out = [];
  const seen = new Set();

  const pushKey = (k) => {
    if (!seen.has(k)) {
      seen.add(k);
      out.push(k);
    }
  };

  for (const [key, value] of Object.entries(modelMap)) {
    if (value == null || typeof value !== 'object' || !('litellm_provider' in value)) continue;
    const lp = value.litellm_provider;
    if (typeof lp !== 'string') continue;
    if (lp === slug || lp.includes(slug)) pushKey(key);
  }

  // Cohere: cohere 선택 시 cohere_chat 도 포함 (공식 UI 와 동일)
  if (slug === 'cohere') {
    for (const [key, value] of Object.entries(modelMap)) {
      if (value?.litellm_provider === 'cohere_chat') pushKey(key);
    }
  }

  // SageMaker: UI 슬러그가 sagemaker_chat 일 때 레거시 sagemaker 모델도 포함하고 싶다면
  if (slug === 'sagemaker_chat') {
    for (const [key, value] of Object.entries(modelMap)) {
      if (value?.litellm_provider === 'sagemaker') pushKey(key);
    }
  }

  return out.sort((a, b) => a.localeCompare(b));
}

export function toSelectOptions(keys) {
  return keys.map((key) => ({ label: key, value: key }));
}

/** 콤보 value → 비용 맵 필터용 슬러그 */
export function normalizeProviderSlug(raw) {
  if (raw === 'openai-compatible') return 'openai';
  return raw;
}